import { useEffect, useState } from 'react';
import { fetchBlogs } from '../api/blogs';
import { Link } from 'react-router-dom';
import { API_BASE_URL } from '../utils/constants';

const stripHtml = (html) => {
  if (!html) return "";
  const temp = document.createElement("div");
  temp.innerHTML = html;
  return temp.textContent || temp.innerText || "";
};

const Blog = () => {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    const load = async () => {
      try {
        const data = await fetchBlogs();
        setBlogs(data);
      } catch (err) {
        console.error('Failed to load blogs:', err);
      }
    };
    load();
  }, []);

  return (
    <div className="px-6 py-10 max-w-5xl mx-auto">
      <h1 className="text-3xl font-bold mb-10 text-center">Blog</h1>

      <div className="space-y-10">
        {blogs.map((post) => {
          // EXCERPT PREVIEW (fallback to content if excerpt missing)
          const previewText = post.excerpt?.trim()?.length
            ? post.excerpt
            : stripHtml(post.content).slice(0, 200) + "...";

          return (
            <div
              key={post.id}
              className="group border rounded-xl overflow-hidden shadow-sm hover:shadow-md transition-shadow"
            >
              {/* Cover Image */}
              {post.image && (
                <div className="w-full h-56 overflow-hidden bg-gray-200">
                  <img
                    src={`${API_BASE_URL}/uploads/blogs/${post.image}`}
                    alt={post.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
              )}

              <div className="p-6 flex flex-col">
                <h2 className="text-2xl font-semibold mb-2 group-hover:text-indigo-600 transition-colors">
                  {post.title}
                </h2>

                <p className="text-sm text-gray-500">{post.date || ""}</p>

                <p className="mt-3 text-gray-700 leading-relaxed">
                  {previewText}
                </p>

                <Link
                  to={`/blog/${post.id}`}
                  className="self-start mt-5 inline-flex items-center gap-2 px-4 py-2 text-sm font-medium
                             text-indigo-700 bg-indigo-100 rounded-lg hover:bg-indigo-200
                             transition-colors"
                >
                  Pročitaj više
                  <span className="transform group-hover:translate-x-1 transition-transform">→</span>
                </Link>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Blog;
